import { getAccessToken } from "auth/tokenStore";

const DEFAULT_BUILDER_URL = "https://builder.pearlcrm.com.au";

// Opens the storefront builder for a site and hands it the current session
// once the builder window announces it is ready. Returns an error message, or
// null when the window opened.
export default function openStorefrontBuilder(siteId) {
  if (!siteId) return "Save this website before opening the storefront builder.";
  const token = getAccessToken();
  if (!token) return "Your PearlCRM session has expired. Sign in again before opening the storefront builder.";
  const baseUrl = (process.env.REACT_APP_STOREFRONT_BUILDER_URL || DEFAULT_BUILDER_URL).replace(/\/$/, "");
  let builderOrigin;
  try {
    builderOrigin = new URL(baseUrl).origin;
  } catch {
    return "The storefront builder URL is not configured correctly.";
  }
  const popup = window.open(`${baseUrl}?site=${encodeURIComponent(siteId)}`, "pearlcrm-storefront-builder");
  if (!popup) return "Your browser blocked the storefront builder window. Allow pop-ups and try again.";
  const handoff = (event) => {
    if (
      event.origin !== builderOrigin
      || event.source !== popup
      || event.data?.type !== "pearlcrm:builder-ready"
      || event.data?.siteId !== siteId
    ) return;
    popup.postMessage({ type: "pearlcrm:builder-session", accessToken: token }, builderOrigin);
    window.removeEventListener("message", handoff);
  };
  window.addEventListener("message", handoff);
  window.setTimeout(() => window.removeEventListener("message", handoff), 60_000);
  return null;
}
